const cardItems = [
  {
    title: '《第二十条》',
    tag: '推荐',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '张艺谋导演现实主义力作，雷佳音马丽主演，笑中带泪直击人心',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20warm%20courtroom%20lighting%2C%20dramatic%20legal%20drama%20atmosphere%2C%20soft%20golden%20and%20amber%20tones%2C%20professional%20film%20still%20aesthetic%20with%20shallow%20depth%20of%20field%2C%20clean%20background%20with%20subtle%20gradient%2C%20editorial%20movie%20poster%20style&width=600&height=400&seq=card-1-51video&orientation=landscape',
  },
  {
    title: '《繁花》全集',
    tag: '热播',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '王家卫首部电视剧，胡歌马伊琍主演，上海滩风云再现荧屏',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20Shanghai%20atmosphere%20with%20warm%20neon%20lights%2C%201990s%20Chinese%20cityscape%20vibe%2C%20elegant%20and%20artistic%20film%20aesthetic%2C%20soft%20golden%20hour%20lighting%20on%20urban%20streets%2C%20cinematic%20composition%20with%20rich%20warm%20tones%2C%20simple%20clean%20background%20with%20bokeh&width=600&height=400&seq=card-2-51video&orientation=landscape',
  },
  {
    title: '《热辣滚烫》',
    tag: '新片',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '贾玲自导自演励志喜剧，拳击场上演热血逆袭，笑泪交织',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20boxing%20gym%20scene%20with%20warm%20spotlight%20and%20motivational%20energy%2C%20dramatic%20lighting%20on%20boxing%20ring%2C%20cinematic%20sports%20drama%20aesthetic%2C%20golden%20and%20crimson%20warm%20color%20palette%2C%20simple%20dark%20background%20with%20atmospheric%20light%20rays&width=600&height=400&seq=card-3-51video&orientation=landscape',
  },
  {
    title: '《大奉打更人》',
    tag: '热播',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '王鹤棣主演古装探案剧，爆笑与悬疑并存，古代奇幻世界观',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20palace%20scene%20with%20warm%20lantern%20light%2C%20mysterious%20detective%20atmosphere%2C%20rich%20crimson%20and%20gold%20color%20scheme%2C%20dramatic%20shadows%20and%20soft%20glow%2C%20cinematic%20costume%20drama%20aesthetic%2C%20simple%20dark%20background&width=600&height=400&seq=card-4-51video&orientation=landscape',
  },
  {
    title: '《年会不能停》',
    tag: '高分',
    tagColor: 'bg-secondary-100 text-secondary-700',
    desc: '大鹏白客职场喜剧天花板，笑点密集讽刺拉满，打工人的嘴替',
    img: 'https://readdy.ai/api/search-image?query=Modern%20office%20comedy%20scene%20with%20warm%20indoor%20lighting%2C%20humorous%20corporate%20atmosphere%2C%20bright%20and%20lively%20color%20palette%20with%20golden%20tones%2C%20professional%20yet%20playful%20composition%2C%20clean%20modern%20office%20background&width=600&height=400&seq=card-5-51video&orientation=landscape',
  },
  {
    title: '《与凤行》',
    tag: '推荐',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '赵丽颖林更新二搭古装仙侠，特效炸裂剧情上头',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20with%20floating%20clouds%20and%20warm%20sunset%20glow%2C%20magical%20and%20romantic%20atmosphere%2C%20soft%20golden%20and%20rose%20pink%20color%20palette%2C%20cinematic%20costume%20drama%20composition%2C%20simple%20dreamy%20background&width=600&height=400&seq=card-6-51video&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">编辑团队精心挑选，每周更新优质影视内容，品质保障不踩雷</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {cardItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute top-3 left-3">
                  <span className={`text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}